import { render, staticRenderFns } from "./InReportDetail.vue?vue&type=template&id=83d0d97c"
import script from "./InReportDetail.vue?vue&type=script&lang=js"
export * from "./InReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports